<style scoped>
.content-wrapper .content{
  padding-top: 95px;
}
.el-select{
  display: block;
}
</style>
<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="content-wrapper">
    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Create Header Bidding tag for {{ (is_amp) ? 'AMP' : 'DISPLAY' }}</h3>
        </div>
        <div class="box-body">
          <form method="post" v-on:submit.prevent="createTag" class="form">

            <h5>Publisher's Unit</h5>
            <el-switch active-text="" inactive-text="" active-color="#13ce66" inactive-color="#ff4949" v-model="isPubUnit" @change="pubUnitToggle">Publisher's Unit</el-switch>

            <div>
              <h5>Select Dimension/s</h5>
              <div class="row">
                <div class="col-md-9">
                  <el-select v-model="hb_tag.dimensions" placeholder="Select" multiple filterable>
                    <el-option v-for="dimension in dimensions" :data-id="dimension.id" :label="dimension.width + 'x' + dimension.height" :value="dimension.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <hr>
            </div>

            <div v-if="!isPubUnit">
              <h5>Enter tag post fix</h5>
              <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="post_fix" type="text" placeholder="Enter tag post fix" v-model="hb_tag.post_fix"></el-input>
              <!-- <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span> -->
              <hr>
            </div>

            <div>
              <h5 style="padding-top: 10px;">DFP Ad unit path:  {{ (is_amp) ? getDfpAdUnitPathAmp(hb_tag).replace(null,'') : getDfpAdUnitPathDisplay(hb_tag).replace(null,'') }}</h5>
            </div>

            <div>
              <h5 v-if="domainMcmEnabled || (isPubUnit || is_amp)">Override DFP network code here</h5>
              <button v-if="!mcm_enabled && (isPubUnit || (!domainMcmEnabled && is_amp))" @click="resetNetworkCode($event)" class="el-button el-button--success pull-right" style="margin-bottom: 10px;" >
                <i class="el-icon-refresh"></i>
                Reset to default
              </button>
              <el-input v-if="!mcm_enabled && (isPubUnit || (!domainMcmEnabled && is_amp))" class = "" v-validate="'required'" data-vv-delay="1000" name="network_override" type="text" placeholder="Enter DFP Network Override" v-model="hb_tag.network_override"></el-input>
              <!-- <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span> -->
              <div v-if="(domainMcmEnabled && !isPubUnit)">
                <h5>Is MCM Enabled?</h5>
                <el-switch active-text="" inactive-text="" active-color="#13ce66" inactive-color="#ff4949" v-model="mcm_enabled" @change="resetMCM">Is sticky Unit?</el-switch>
              </div>
              <div class="row" v-if="!isPubUnit && (mcm_enabled && domainMcmEnabled)">
              <div class="col-md-3" style="">
                    <h5>Select MCM Delegation Type:</h5>
                    <el-select v-model="account_type" placeholder="Select MCM Delegation Type" @change="filterNetworkList">
                            <el-option v-for="(mcm_account_type,id) in mcmAccountType" :data-id="id" :label="mcm_account_type.account_type.replaceAll('_',' ')" :value="mcm_account_type.account_type" :key="id">
                            </el-option>
                    </el-select>
              </div>
              <div class="col-md-3">
                        <h5>Select Child DFP Network</h5>
                        <el-select :disabled="account_type==null" v-model="child_dfp_network" filterable placeholder="Select Child DFP Network">
                            <!-- <el-option key="" label="Select a DFP Network" value=""></el-option> -->
                            <el-option v-for="network in filteredAccountList" :key="network.id" :label="`${network.child_network_code +' : ' + network.name}`" :value="network.child_network_code">
                            </el-option>
                        </el-select>
                    </div>
              <div class="col-md-3">
								<h5>Add DFP Parent Adunit Id</h5>
								<el-input :disabled="account_type==null && child_dfp_network==null" placeholder="Add DFP Parent Adunit Id" v-model="dfp_parent_ad_unit_id"></el-input>
							</div>
               <div class="col-md-3">
								<h5>Add DFP Parent Adunit Path</h5>
								<el-input :disabled="account_type==null || child_dfp_network==null || dfp_parent_ad_unit_id==0" placeholder="Add DFP Parent Adunit Path" v-model="dfp_parent_ad_unit_path"></el-input>
							</div>
              </div>
              <hr>
            </div>
            <div v-if="is_amp">
              <h5>Select Currency for AMP</h5>

              <el-select v-model="hb_tag.currencyId" placeholder="Select">
                 <el-option
                    v-for="option in currenciesOptions"
                    :key="option.id"
                    :label="option.code"
                    :value="option.id">
                 </el-option>
              </el-select>
              <!-- <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span> -->
              <hr>
            </div>

            <div v-if="is_amp">
              <h5>Is AMP sticky Unit?</h5>
              <el-switch active-text="" inactive-text="" active-color="#13ce66" inactive-color="#ff4949" v-model="hb_tag.is_amp_sticky">Is sticky Unit?</el-switch>
              <hr>
            </div>


            <div v-if="isPubUnit">
              <h5>Enter publisher's DFP Ad unit path</h5>
              <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="post_fix" type="text" placeholder="Enter publisher's DFP Ad unit path" v-model="hb_tag.pub_dfp_unit_path"></el-input>
              <!-- <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span> -->
              <hr>
            </div>

            <div v-if="isPubUnit">
              <h5>Enter publisher's DFP Ad unit id</h5>
              <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="post_fix" type="number" placeholder="Enter publisher's DFP Ad unit id" v-model="hb_tag.pub_dfp_unit_id"></el-input>
              <!-- <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span> -->
              <hr>
            </div>



            <!-- <h5>Enter floor price (in USD)</h5>
            <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="floor" type="number" step="0.01" v-model="hb_tag.floor" :value="hb_tag.floor"></el-input>
            <hr> -->


            <div class="clearfix">
              <button type="submit" class="el-button el-button--success" :disabled="!isComplete">
                <i class="el-icon-plus el-icon-left"></i>
                Create tag
              </button>
              <router-link :to="(is_amp)? `/admin/publisher/${this.pubUuid}/domain/${this.domId}/hb-tags-amp/` : `/admin/publisher/${this.pubUuid}/domain/${this.domId}/hb-tags/`" class="el-button el-button--danger">
                Cancel
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    data() {
      return {
        is_duplicate:false,
        dfp_parent_ad_unit_path:null,
        dfp_parent_ad_unit_id:0,
        hbId:null,
        frmData:'',
        domainMcmEnabled:false,
        filteredAccountList:[],
        domainNetworkDelegation:'',
        domainChildNetwork:null,
        mcm_enabled:false,
        account_type:null,
        child_dfp_network:null,
        currenciesOptions: [],
        activeNames: ['1'],
        dimensions: [],
        pubUuid: this.$route.params.uuid,
        domId: this.$route.params.domId,
        isPubUnit: false,
        current_dfp_network:null,
        pubUid: undefined,
        domain_details: undefined,
        mcmAccountType:[],
        childDfpAccounts:[],
        hb_tag: {
          name: '',
          post_fix: '',
          enabled: true,
          dimensions: undefined,
          currencyId: '',
          device_type: 'web',
          domain_id: this.$route.params.domId,
          floor: 0.0,
          pub_dfp_unit_path: '',
          pub_dfp_unit_id: '',
          is_amp: this.is_amp,
          is_amp_sticky: false,
          network_override: ''
        },
        options: [{
          value: 'instream',
          label: 'instream'
        }, {
          value: 'outstream',
          label: 'outstream'
        }],
        value: '',
        player_dimension:'',
        vpdimension:[{
          value:'320 x 460',
          label:'320 x 460'
        }, {
          value:'860 x 420',
          label:'860 x 420'
        }]
      };
    },
    props: {
      is_amp: Boolean
    },
    created: function(){
      const self = this;
      this.pubUid = this.$route.params.uuid;
      this.hbId = this.$route.query.hb_id
      axios.all([
        axios.get(BASE_URL + 'v1/ad-dimensions/'),
        axios.get(BASE_URL + `v1/publishers/${this.pubUid}/domains/${this.domId}/`),
        axios.get(BASE_URL + 'v1/currencies/'),
        axios.get(BASE_URL + 'v1/child-dfp-network-list/'),
        axios.get(BASE_URL + 'v1/mcm-account-list/')
      ])
      .then(axios.spread(function(dimensions, domain, currencies,childAccounts,mcm_type) {
        console.log(dimensions.data);
        self.dimensions = dimensions.data;
        self.domain_details = Object.assign({},domain.data);
        self.domainNetworkDelegation = (domain.data.mcm)?domain.data.mcm.account_type:self.domainNetworkDelegation
        self.domainMcmEnabled = domain.data.mcm_enable
        self.domainChildNetwork = (domain.data.child_dfp_network)?domain.data.child_dfp_network.child_network_code:self.domainChildNetwork
        self.currenciesOptions = currencies.data
        self.mcmAccountType = mcm_type.data
        self.childDfpAccounts = childAccounts.data
        currencies.data.map((k)=>{if(k.code=='USD'){return self.hb_tag.currencyId=k.id}})
        
        self.hb_tag.network_override = (!self.isPubUnit && self.domain_details.mcm_enable==true)?(self.domain_details.mcm.account_type=='MANAGE_ACCOUNT')?self.domain_details.child_dfp_network.child_network_code:self.domain_details.dfp_network.network_code:self.domain_details.dfp_network.network_code;

        self.dfp_parent_ad_unit_id = (self.account_type==null)?(self.is_amp)?self.domain_details.amp_parent_ad_unit_id:self.domain_details.parent_ad_unit_id:self.dfp_parent_ad_unit_id

        self.dfp_parent_ad_unit_path = (self.account_type==null)?(self.is_amp)?self.domain_details.amp_parent_ad_unit_code:self.domain_details.parent_ad_unit_code:self.dfp_parent_ad_unit_path

        self.current_dfp_network=self.domain_details.dfp_network.network_code
        if(!self.hbId){
          self.setMcmInit(self.domain_details)
        }
      }))
      .catch(error => console.log(error))

      if(this.hbId){
        axios.get(`${BASE_URL}v1/${(this.is_amp)?'amp_hb_tags':'hb_tags'}/${this.domId}/`)
        .then(function(data){
          self.is_duplicate=true
          self.frmData = data.data.response_data.hb_tags
          self.curUnit = self.frmData.filter(t=>{if(t.id==self.hbId) return t})[0];
        console.log(self.curUnit);
          self.dfp_parent_ad_unit_id = (self.domainMcmEnabled==false)?self.curUnit.dfp_parent_ad_unit_id:self.dfp_parent_ad_unit_id
        self.hb_tag.currencyId = (self.curUnit.hasOwnProperty("amp_currency_id") && self.curUnit.amp_currency_id!='')?self.curUnit.amp_currency_id : ''
        console.log(self.hb_tag.currencyId)
        self.hb_tag.is_amp_sticky = self.curUnit.is_amp_sticky
        if(self.hb_tag.currencyId==''){
          currencies.data.map((k)=>{if(k.code=='USD'){return self.hb_tag.currencyId = k.id}})
        }
        self.isPubUnit = self.curUnit.publisher_dfp_unit
        if(!self.isPubUnit){
          setTimeout(function(e){
            self.setMcmInit(self.domain_details)
          },500)
          
        }
        self.hb_tag.floor = self.curUnit.floor
        self.hb_tag.post_fix = (self.curUnit.post_fix=='null')?'':self.curUnit.post_fix
        self.hb_tag.pub_dfp_unit_path = self.curUnit.dfp_ad_unit_code
        self.hb_tag.pub_dfp_unit_id = self.curUnit.dfp_ad_unit_id
        self.hb_tag.dimensions = self.curUnit.dimensions.map((i)=>{return (i.id)})
        setTimeout(function(e){
        self.hb_tag.network_override = (self.curUnit.network_override)?self.curUnit.network_override:self.curUnit.current_dfp_network
        
        
        self.account_type = (self.curUnit.mcm_account_switch && self.domainMcmEnabled==true && !self.isPubUnit)?self.curUnit.mcm_account_switch:self.account_type
        
        self.mcm_enabled = (self.account_type!=null && self.domainMcmEnabled==true && !self.isPubUnit)?true:false
        
        self.child_dfp_network = (self.curUnit.child_network_override && self.domainMcmEnabled==true && !self.isPubUnit)?self.curUnit.child_network_override:self.child_dfp_network

        
        self.filteredAccountList = self.childDfpAccounts.filter(k=>{return (k.delegation_type == self.account_type)})
        
        self.current_dfp_network=(self.curUnit.current_dfp_network)?self.curUnit.current_dfp_network:self.current_dfp_network

        self.dfp_parent_ad_unit_id=(self.curUnit.dfp_parent_ad_unit_id)?self.curUnit.dfp_parent_ad_unit_id:self.dfp_parent_ad_unit_id

        self.dfp_parent_ad_unit_path=(self.curUnit.dfp_parent_ad_unit_path)?self.curUnit.dfp_parent_ad_unit_path:self.dfp_parent_ad_unit_path
        },200)

        })
        .catch(function(e){
          console.log('hb err',e)
        })
      }

    },
    methods: {
      setMcmInit(domain){
        var self=this
        // console.log('ppppp',domain,self.is_duplicate)
        if(self.is_duplicate){
          self.dfp_parent_ad_unit_id=(self.curUnit.dfp_parent_ad_unit_id)?self.curUnit.dfp_parent_ad_unit_id:self.dfp_parent_ad_unit_id

          self.dfp_parent_ad_unit_path=(self.curUnit.dfp_parent_ad_unit_path)?self.curUnit.dfp_parent_ad_unit_path:self.dfp_parent_ad_unit_path

          self.account_type = (self.curUnit.mcm_account_switch && self.domainMcmEnabled==true && !self.isPubUnit)?self.curUnit.mcm_account_switch:self.account_type
          self.mcm_enabled = (self.account_type!=null && self.domainMcmEnabled==true && !self.isPubUnit)?true:false
          
          self.child_dfp_network = (self.curUnit.child_network_override && self.domainMcmEnabled==true && !self.isPubUnit)?self.curUnit.child_network_override:self.child_dfp_network

          // self.filteredAccountList = self.childDfpAccounts.filter(k=>{return (k.delegation_type == self.account_type)})
        }
        else{
          self.mcm_enabled = domain.mcm_enable
          if(self.mcm_enabled){
            self.child_dfp_network=domain.child_dfp_network.child_network_code
            self.account_type = domain.mcm.account_type
            self.dfp_parent_ad_unit_path = (self.is_amp)?domain.amp_parent_ad_unit_code:domain.parent_ad_unit_code
            self.dfp_parent_ad_unit_id = (self.is_amp)?domain.amp_parent_ad_unit_id:domain.parent_ad_unit_id
            self.filteredAccountList = self.childDfpAccounts.filter(k=>{return (k.delegation_type == self.account_type)})
          }
        }
      },
      filterNetworkList(){
            var selectedAccount = this.account_type
            this.filteredAccountList = this.childDfpAccounts.filter(k=>{return (k.delegation_type == selectedAccount)})
            this.child_dfp_network=null
        },
      resetMCM(){
        this.account_type = null
        this.child_dfp_network=null
        // this.dfp_parent_ad_unit_id=0
        // this.dfp_parent_ad_unit_path=null
      },
      handleChange(val) {
        console.log(val);
      },
      getDimension(ids){
        console.log(ids);
        console.log(this.dimensions);
        if(ids){
          if(ids.length > 1){
            return 'MULTISIZE'
          }
          else{
            for(let i=0; i<this.dimensions.length; i++){
              if(this.dimensions[i].id == ids[0]){
                return this.dimensions[i].width + 'x' + this.dimensions[i].height;
              }
            }
          }
        }
      },
      createTag(){
        if(this.account_type == "MANAGE_ACCOUNT" && this.dfp_parent_ad_unit_id == 0){
				this.$notify({
							title: 'Error',
							message: "please add dfp parent ad unit id",
							type: 'Error'
					});
				return;
			}
        console.log('createTag calleddd');
        console.log(this.hb_tag);
        console.log("network_override" , this.hb_tag);
        console.log("domain_details",this.domain_details.dfp_network);
        let request_object = {
          enabled: this.hb_tag.enabled,
          dimensions: this.hb_tag.dimensions,
          domain_id: this.hb_tag.domain_id,
          floor: this.hb_tag.floor,
          pub_dfp_unit_path: this.hb_tag.pub_dfp_unit_path,
          pub_dfp_unit_id: this.hb_tag.pub_dfp_unit_id,
          isPubUnit: this.isPubUnit,
          is_amp: this.is_amp,
          is_amp_sticky: this.hb_tag.is_amp_sticky,
          amp_currency: this.hb_tag.currencyId,
          network_code: (this.domainMcmEnabled)?this.hb_tag.network_override:(this.hb_tag.network_override != this.domain_details.dfp_network.network_code) ? this.hb_tag.network_override : null,
          current_dfp_network: this.current_dfp_network,
          dfp_parent_ad_unit_id: this.dfp_parent_ad_unit_id
        }
        console.log(request_object);
        if(!this.isPubUnit){
          request_object.name = 'ATD_' + this.getDimension(this.hb_tag.dimensions) + '_' + this.hb_tag.post_fix;
          request_object.post_fix = this.hb_tag.post_fix;
          
          request_object.mcm_account_switch = this.account_type
          request_object.child_network_override = this.child_dfp_network
          request_object.dfp_parent_ad_unit_path = this.dfp_parent_ad_unit_path;
          request_object.dfp_parent_ad_unit_id = this.dfp_parent_ad_unit_id
        }
        else{
          request_object.dfp_parent_ad_unit_path = 'null';
          request_object.name = this.hb_tag.pub_dfp_unit_path;
          request_object.post_fix = 'null';
          request_object.mcm_account_switch = this.account_type
          request_object.child_network_override = this.child_dfp_network
          request_object.dfp_parent_ad_unit_id = 0
        }

        axios.post(BASE_URL + 'v1/create_hb_tag/', request_object)
        .then(response => {
          if(response.data.status == 'success'){
            this.$notify({
              title: 'Success',
              message: response.data.message,
              type: 'success'
            });
            setTimeout(() => {
              if(this.is_amp)
                this.$router.push(`/admin/publisher/${this.pubUuid}/domain/${this.domId}/hb-tags-amp/?tag_id=${response.data.tag_id}`);
              else
                this.$router.push(`/admin/publisher/${this.pubUuid}/domain/${this.domId}/hb-tags/?tag_id=${response.data.tag_id}`);
            }, 500);
          }
          else if(response.data.status == 'error'){
            this.$notify({
              title: 'Error !!',
              message: response.data.message,
              type: 'error'
            });
            this.activeNames = '';
          }
        })
        .catch(error => console.log(error))
      },
      getDfpAdUnitPathDisplay(hb_tag){
        console.log(hb_tag);
        console.log(this.domain_details);
        console.log(this.hb_tag.network_override);
        // console.log(this.domain_details.amp_parent_ad_unit_code);
        // console.log(this.domain_details.parent_ad_unit_code);
        let path = '';
        if(this.domain_details){
          var network_code=''
          if(this.account_type){
            if(this.account_type=='MANAGE_INVENTORY'){
              // network_code=this.domain_details.dfp_network.network_code+','+this.child_dfp_network
              network_code=this.current_dfp_network+','+this.child_dfp_network
            }else{
              network_code=this.child_dfp_network
            }
          }else if(this.hb_tag.network_override && (this.hb_tag.network_override != this.domain_details.dfp_network.network_code || this.isPubUnit)){
            network_code=this.hb_tag.network_override
          }else{
            if(this.current_dfp_network){
              network_code=this.current_dfp_network
            }else{
              if(this.domain_details.mcm_enable){
                if(this.domain_details.mcm.account_type=='MANAGE_INVENTORY'){
                  network_code=this.domain_details.dfp_network.network_code+','+this.domain_details.child_dfp_network.child_network_code
                }
                else{
                  network_code=this.domain_details.child_dfp_network.child_network_code
                }
              }else{
                network_code=this.domain_details.dfp_network.network_code
              }
            }
          }

          var dfp_parent_code = this.domain_details.parent_ad_unit_code

          if(this.isPubUnit){
            dfp_parent_code = hb_tag.pub_dfp_unit_path
          }else{
            if(this.account_type  && this.dfp_parent_ad_unit_id!=0){
              dfp_parent_code = this.dfp_parent_ad_unit_path
            }else{
              if(this.is_amp){
                dfp_parent_code = this.domain_details.amp_parent_ad_unit_code
              }
              else{
                dfp_parent_code = this.domain_details.parent_ad_unit_code
              }
            }
          }

          
          path = `${network_code}/${dfp_parent_code}`
          if(!this.isPubUnit) path += `/ATD_${(this.getDimension(hb_tag.dimensions) ? this.getDimension(hb_tag.dimensions) : ' ')}_${hb_tag.post_fix}`;
        }
        return path;
        // return `ATD_${(getDimension(hb_tag.dimensions) ? getDimension(hb_tag.dimensions) : ' ')}_${hb_tag.post_fix}`
      },
      getDfpAdUnitPathAmp(hb_tag){
        console.log(hb_tag);
        console.log(this.domain_details);
        console.log(";;",this.hb_tag.network_override);
        // console.log(this.domain_details.amp_parent_ad_unit_code);
        // console.log(this.domain_details.parent_ad_unit_code);
        let path = '';
        if(this.domain_details){
          var network_code=this.domain_details.dfp_network.network_code
          if(this.account_type){
            if(this.account_type=='MANAGE_INVENTORY'){
              // network_code=this.domain_details.dfp_network.network_code+','+this.child_dfp_network

              network_code=this.current_dfp_network+','+this.child_dfp_network
            }else{
              network_code=this.child_dfp_network
            }
          }else if(this.hb_tag.network_override && this.hb_tag.network_override != this.current_dfp_network){
            network_code=this.hb_tag.network_override
          }else{
            if(this.current_dfp_network){
              network_code=this.current_dfp_network
            }else{
              if(this.domain_details.dfp_network.mcm_enable){
                if(this.domain_details.dfp_network.mcm.account_type=='MANAGE_INVENTORY'){
                  network_code=this.domain_details.dfp_network.network_code+','+this.domain_details.dfp_network.child_dfp_network.child_network_code
                }
                else{
                  network_code=this.domain_details.dfp_network.child_dfp_network.child_network_code
                }
              }else{
                network_code=network_code
              }
            }
          }

          var dfp_parent_code = hb_tag.pub_dfp_unit_path

          if(this.isPubUnit){
            dfp_parent_code = hb_tag.pub_dfp_unit_path
          }else{
            if(this.account_type && this.dfp_parent_ad_unit_id!=0){
              dfp_parent_code = this.dfp_parent_ad_unit_path
            }else{
              dfp_parent_code = this.domain_details.amp_parent_ad_unit_code
            }
          }
        
          path = `${network_code}/${dfp_parent_code}`;
          if(!this.isPubUnit) path += `/ATD_${(this.getDimension(hb_tag.dimensions) ? this.getDimension(hb_tag.dimensions) : ' ')}_${hb_tag.post_fix}`;
        }
        return path;
        // return `ATD_${(getDimension(hb_tag.dimensions) ? getDimension(hb_tag.dimensions) : ' ')}_${hb_tag.post_fix}`
      },
      resetNetworkCode(event){
        event.preventDefault();
        console.log(event);
        this.hb_tag.network_override = (this.domain_details.mcm_enable==true)?(this.domain_details.mcm.account_type=='MANAGE_ACCOUNT')?this.domain_details.child_dfp_network.child_network_code:this.domain_details.dfp_network.network_code:this.domain_details.dfp_network.network_code;
        this.account_type = null
        this.child_dfp_network=null
      },
      pubUnitToggle(val){
        console.log('pppp',val)
        if(!val){
          this.hb_tag.network_override = '';
          this.setMcmInit(this.domain_details)
        }else{
          this.mcm_enabled=false
          this.resetMCM()
        }
        // console.log(this.isPubUnit);
      }
    },
    computed: {
      isComplete(){
        console.log(!this.isPubUnit && (this.hb_tag.post_fix && (this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0) && this.hb_tag.floor));
        
        if(!this.isPubUnit)  return this.hb_tag.post_fix && (this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0) && String(this.hb_tag.floor);
        
        else if(this.mcm_enabled) return this.dfp_parent_ad_unit_path!='' && this.dfp_parent_ad_unit_path!=null && this.dfp_parent_ad_unit_id!=0 && this.account_type!=null && this.child_dfp_network!=null && this.hb_tag.pub_dfp_unit_path && this.hb_tag.pub_dfp_unit_id && String(this.hb_tag.floor) && (this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0) && this.hb_tag.network_override
        
        else  return this.hb_tag.pub_dfp_unit_path && this.hb_tag.pub_dfp_unit_id && String(this.hb_tag.floor) && (this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0) && this.hb_tag.network_override;
      }
    }
  }
</script>





// WEBPACK FOOTER //
// CreateHbTag.vue?28820c54